module.exports = __webpack_public_path__ + "img/onboarding/edit-title-4f8bde9acc750a5203b1225815def30e.svg";